if (__app.site.twitter_username && __app.site.twitter_username !== '' && __app.page.twitter_shares === true) {
    (function(){
        let twitterWidgets = document.createElement('script');
        twitterWidgets.type = 'text/javascript';
        twitterWidgets.async = true;
        twitterWidgets.src = 'https://platform.twitter.com/widgets.js';
        document.getElementsByTagName('head')[0].appendChild(twitterWidgets);
    })();
}



// WEBPACK FOOTER //
// ./src/_assets/js/twitter_sharing.js